import { Component, ViewEncapsulation } from '@angular/core';
import { AuthService } from '../../../shared/services/auth/auth.service';
import { trackByFunction } from '../../../shared/formly/ga-formly.util';
import { PunchoutProtocols } from '../../order/entry/order-entry-data.service';
import { ICatalogCategory } from '../../order/catalog/order-catalog-data.service';

const CATEGORIES:ICatalogCategory[] = [
  {
    name: 'Punch-in Tester',
    type: 'EXTERNAL',
    accessType: 'BUTTON',
    punchoutProtocol: PunchoutProtocols.OCI,
    postUrl: 'https://new-punchout-tester.acslworld.com/punchin',
    message: `1
          <input name="KUNDENNR" value="9000103865">
          <input name="BENUTZER" value="Procurement">
          <input name="KENNWORT" value="OCIlogon201602291BI">
          <input name="SRC" value="SAP">
          <input name="ACTION" value="Anmelden">
          <input name="XMLBASKET" value="TRUE">
          <input name="RETURNTARGET" value="_self">
          <input name="LANGUAGE" value="EN">
          <input name="HOOK_URL" value="{BASE}/ga2/rest/fakecatalog/punchout/?token={TOKEN}">
      `
  },
  {
    name: 'Bechtle Shop 2',
    type: 'EXTERNAL',
    accessType: 'BUTTON',
    punchoutProtocol: PunchoutProtocols.OCI,
    postUrl: 'https://oci.bechtle.com/shop/default_bios.asp#1',
    message: `2
          <input name="KUNDENNR" value="9001121522">
          <input name="BENUTZER" value="Procurement">
          <input name="KENNWORT" value="OCIlogon201602291BI">
          <input name="SRC" value="SAP">
          <input name="ACTION" value="Anmelden">
          <input name="XMLBASKET" value="TRUE">
          <input name="RETURNTARGET" value="_self">
          <input name="LANGUAGE" value="EN">
          <input name="HOOK_URL" value="{BASE}/ga2/rest/fakecatalog/punchout/?token={TOKEN}">
      `
  },
  {
    name: 'Bechtle Shop 3',
    type: 'EXTERNAL',
    accessType: 'BUTTON',
    punchoutProtocol: PunchoutProtocols.OCI,
    postUrl: 'https://oci.bechtle.com/shop/default_bios.asp#2',
    message: `3
          <input name="KUNDENNR" value="9000103865">
          <input name="BENUTZER" value="Procurement">
          <input name="KENNWORT" value="OCIlogon201602291BI">
          <input name="SRC" value="SAP">
          <input name="ACTION" value="Anmelden">
          <input name="XMLBASKET" value="TRUE">
          <input name="RETURNTARGET" value="_self">
          <input name="LANGUAGE" value="EN">
          <input name="HOOK_URL" value="{BASE}/ga2/rest/countries">
      `
  },
  {
    name: 'Bechtle Shop 4',
    type: 'EXTERNAL',
    accessType: 'BUTTON',
    punchoutProtocol: PunchoutProtocols.OCI,
    postUrl: 'https://oci.bechtle.com/shop/default_bios.asp#3',
    message: `4
          <input name="KUNDENNR" value="9000946704">
          <input name="BENUTZER" value="Procurement">
          <input name="KENNWORT" value="OCIlogon201308051BI">
          <input name="SRC" value="SAP">
          <input name="ACTION" value="Anmelden">
          <input name="XMLBASKET" value="TRUE">
          <input name="RETURNTARGET" value="_self">
          <input name="LANGUAGE" value="EN">
          <input name="HOOK_URL" value="{BASE}/ga2/rest/fakecatalog/punchout/?token={TOKEN}">
      `
  }
];

@Component({
  selector: 'punchout-catalog-demo',
  template: `
    <ul>
      <li *ngFor="let category of categories; trackBy: trackByFunction">
        <a (click)="selectCategory($event, category)" href="">Category {{category.name}}</a> &nbsp;
        <i *ngIf="punchoutIsLoading && selectedCategory === category.name" class="fa fa-spinner fa-spin activity-indicator"></i>
      </li>
    </ul>
    <div class="container-punchout">
      <h3>Test Component: punchout-catalog</h3>
      <punchout-catalog *ngIf="selectedCategory" [protocol]="punchoutProtocol" [url]="punchoutPostUrl" [message]="punchoutMessage" (onLoading)="onLoading($event)" (onPunchoutTransfer)="onPunchoutTransfer($event)"></punchout-catalog>
      <pre>{{cart | json}}</pre>
    </div>
	`,
  styleUrls: ['punchout-catalog-demo.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PunchoutCatalogDemoComponent {
  public trackByFunction:Function = trackByFunction;
  private token:string;
  private base:string;

  public punchoutProtocol:PunchoutProtocols;
  public punchoutPostUrl:string;
  public punchoutMessage:string;
  public selectedCategory:string = '';
  public punchoutIsLoading:boolean = false;
  public cart:string;
  public categories:ICatalogCategory[] = CATEGORIES;

  constructor(
    authService:AuthService
  ) {
    this.token = authService.getToken();
    this.base = window.location.origin;
  }

  public selectCategory(event:Event, category):void {
    event.preventDefault();

    this.cart = undefined;

    this.punchoutProtocol = category.punchoutProtocol;
    this.punchoutPostUrl = category.postUrl;
    this.punchoutMessage = category.message.replace('{TOKEN}', this.token).replace('{BASE}', this.base);
    this.selectedCategory = category.name;
  }

  public onLoading(loading):void {
    this.punchoutIsLoading = loading;
  }

  public onPunchoutTransfer(data):void {
    console.log('My Cart: ', data);
    this.cart = data;
    this.selectedCategory = undefined;
  }
}
